import * as React from "react";
import { MainLayout } from "../../components/Layout";
import Headline from "../../components/Headline";
import "./styles.scss";
import LinkButton from "../../components/LinkButton";
import { URL_PATHS } from "../../routes";
import { oneLink } from "../../shared/oneLink";
import AnchorButton from "../../components/AnchorButton";
import { Link } from "react-router-dom";

const TransitionCancelFinish = () => {
    return (
        <MainLayout>
            <Headline>
                クレジットカード決済は
                <br />
                キャンセルされました
            </Headline>
            <section className="transition-cancel-finish">
                <p>
                    ご登録のクレジットカードからお支払いが発生することはございません。
                    <br />
                    サービスは次回更新日までご利用いただけます。
                    <br />
                    また、再度有料会員プランをご利用いただく場合は
                    <Link to={URL_PATHS.myPage()}>マイページ</Link>＞
                    <Link to={URL_PATHS.paymentInfo()}>決済情報</Link>
                    を確認より簡単にご利用を再開することができます。
                </p>
                <div className="user-action">
                    <AnchorButton href={oneLink()}>アプリを開く</AnchorButton>
                    <LinkButton color="secondary" to={URL_PATHS.myPage()}>
                        マイページへ
                    </LinkButton>
                </div>
                <div className="finish-cation">
                    {/*TODO webに退会機能が実装されたら文言を修正する*/}
                    有料会員プランを停止してもアカウントは削除されません。
                    <br />
                    <Link to={URL_PATHS.contractPaidMember()}>
                        退会申請は契約確認・変更から行えます。
                    </Link>
                </div>
            </section>
        </MainLayout>
    );
};

export default TransitionCancelFinish;
